export default "__VITE_ASSET__2lAw2v8D__"